<template>
    <div class="repayment-account-wrapper">
        <div class="form-container">
            <div class="repayment-account-title">阳光产融专区介绍</div>
            <div class="repayment-account-content">在工信部的支持指导下，为落实国家金融服务实体经济提供抓手，促进产业数字金融与产业互联网融合发展，
                实现金融服务全面融入产业生态，为实体经济提供更高质量的金融服务。</div>
            <div class="flex-all-center">
                <eui-btn type="primary" @click="openAccount" v-if="hasSettlementAccount === 1">我已了解，现在去申请开户>></eui-btn>
            </div>
        </div>
        <div class="repayment-account-tip margin-b20" v-if=" hasSettlementAccount === 0">
            企业还未开通统一支付账户，请先申请开通
            <span style="color: #0064c8;cursor:pointer" @click="toPath('supplyServiceCapabilityInfo')" >统一支付账户。</span>
        </div>
    </div>
</template>

<script>
    import api from '@/modules/projectA/api/pay/index';
    import { easySeries } from '@/modules/projectA//api/config';
    export default {
        name: "repaymentNotOpened",
        props:{
            baseInfo:{},
        },
        data(){
            return{
                hasSettlementAccount:2,
            }
        },
        methods:{
            toPath(){
              this.$router.push({
                path: '/paymentAccount'
              })
            },
            openAccount(){
                this.$router.push({path:'/repaymentApplyActivation'});
            },
        },
        watch:{
            baseInfo:{
                immediate: true,
                deep:true,
                handler: function (newval) {
                    if(newval && Object.keys(newval).length > 0){
                        this.hasSettlementAccount = newval.hasSettlementAccount;
                    }
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .repayment-account-wrapper{
        .repayment-account-title{
            color: #333;
            font-size: 16px;
        }
        .repayment-account-content{
            font-size: 14px;
            color: #000;
            text-indent: 2em;
            margin: 20px 0;
        }
        .repayment-account-tip {
            padding-left: 10px;
            height: 44px;
            line-height: 44px;
            background-color: #E8EFFF;
            color: #333;
            font-size: 14px;
        }
    }

</style>